import { Event, EventId, GetChallengesResponse } from './types';
import { baseApi } from './base-api';
import { changeActiveTask } from '../slices/solution';

export const eventApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEventDetailsById: builder.query<Event, EventId>({
      query: (eventId) => `events/details/${eventId}/before_event`,
      transformResponse: (response: { data: Event }) => response.data,
    }),
    getEventChallenges: builder.query<GetChallengesResponse, EventId>({
      query: (eventId) => `events/details/${eventId}/during_venture`,
      transformResponse: (response: { data: GetChallengesResponse }) =>
        response.data,
      onQueryStarted: async (arg, api) => {
        const { data } = await api.queryFulfilled;

        api.dispatch(
          changeActiveTask({
            task: data.challenges[0],
          }),
        );
      },
    }),
  }),
});

export const {
  useGetEventDetailsByIdQuery,
  useGetEventChallengesQuery,
  util: { getRunningQueriesThunk },
} = eventApi;

export const { getEventDetailsById, getEventChallenges } = eventApi.endpoints;
